import React from 'react';
import { Link } from 'react-router-dom';

const TONE_CLASSES = [
  'donezo-stat-card--tone-0',
  'donezo-stat-card--tone-1',
  'donezo-stat-card--tone-2',
  'donezo-stat-card--tone-3',
];

const ICON_VARIANTS = ['', '--alt1', '--alt2', '--alt3'];

function formatWr(wr) {
  if (wr == null || wr === '') return null;
  const n = Number(wr);
  if (Number.isNaN(n)) return String(wr);
  return `${n % 1 === 0 ? n : n.toFixed(1)}%`;
}

/**
 * Species highlight card — biggest fish per type.
 */
export default function DashboardSpeciesStatCard({
  title,
  colorIndex = 0,
  icon = 'fa-fish',
  colClass = 'col-sm-6 col-lg-4 col-xl-3',
  to,
  length,
  weight,
  wr,
  footer,
  primaryValue,
  lines = [],
}) {
  const tone = TONE_CLASSES[colorIndex % TONE_CLASSES.length];
  const variant = ICON_VARIANTS[colorIndex % ICON_VARIANTS.length];
  const iconClass = `donezo-stat-icon${variant ? ` donezo-stat-icon${variant}` : ''}`;
  const wrLabel = formatWr(wr);
  const hasStructuredMetrics = length != null || weight != null || wrLabel != null;

  const card = (
    <div className={`donezo-stat-card donezo-stat-card--species ${tone}`}>
      <div className="donezo-stat-card__top">
        <div className={iconClass}>
          <i className={`fa ${icon} fa-fw`} aria-hidden />
        </div>
        <div className="donezo-stat-body">
          <div className="donezo-stat-species-name">{title}</div>
          {!hasStructuredMetrics && primaryValue ? (
            <div className="donezo-stat-value donezo-stat-value--sm">{primaryValue}</div>
          ) : null}
        </div>
        {wrLabel ? (
          <span className="donezo-stat-wr-pill" title="Relative weight">
            WR {wrLabel}
          </span>
        ) : null}
      </div>

      {hasStructuredMetrics ? (
        <div className="donezo-stat-metrics">
          <div className="donezo-stat-metric">
            <span className="donezo-stat-metric__label">Length</span>
            <span className="donezo-stat-metric__value">{length ?? '—'}</span>
          </div>
          <div className="donezo-stat-metric donezo-stat-metric--divider" aria-hidden />
          <div className="donezo-stat-metric">
            <span className="donezo-stat-metric__label">Weight</span>
            <span className="donezo-stat-metric__value">{weight ?? '—'}</span>
          </div>
        </div>
      ) : null}

      {!hasStructuredMetrics && lines.length > 0 ? (
        <div className="donezo-stat-card__legacy-lines">
          {lines.map((line, idx) => (
            <div key={idx} className="donezo-stat-desc">
              {line}
            </div>
          ))}
        </div>
      ) : null}

      {footer ? <div className="donezo-stat-footer">{footer}</div> : null}
    </div>
  );

  return (
    <div className={colClass}>
      {to ? (
        <Link to={to} className="donezo-stat-card-link">
          {card}
        </Link>
      ) : (
        card
      )}
    </div>
  );
}
